<script>
    import {APP_VERSION} from "./lib/constants";
    import Route, {router} from "./lib/Router/Router.svelte";
    import {cookie} from "./lib/cookie";
    import R from "./lib/requests";
    import app from './stores/app';
    import user from "./stores/user";
    import Login from "./account/Login.svelte";
    import ForgotPassword from "./components/pages/ForgotPassword.svelte";
    import AppHeader from "./components/AppHeader.svelte";
    import AppMenu from "./components/AppMenu.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import Dashboard from "./dashboard/Dashboard.svelte";
    import Hotels from "./hotels/Hotels.svelte";
    import SignUp from "./account/SignUp.svelte";
    import SignUpConfirm from "./account/SignUpConfirm.svelte";
    import ResetPassword from "./account/ResetPassword.svelte";
    import Account from "./account/Account.svelte";
    import CheckIn from "./account/CheckIn.svelte";
    import PointsLog from "./account/PointsLog.svelte";
    import TransferPoints from "./account/TransferPoints.svelte";
    import AcceptPoints from "./account/AcceptPoints.svelte";

    let appInitialized = false;

    const initializeUser = async () => {
        let coo = cookie.get('enorme-loyalty') || null;
        if (coo) {
            $user.token = coo;
        }
    }

    const initializeApp = () => {
        const onSuccess = result => {
            if (result.user) {
                user.setUser(result.user);
            }

            $app.debugNotifications = result.debug_notifications == 1;

            if (APP_VERSION !== result.app_version) {
                alert("Η έκδοση της εφαρμογής που χρησιμοποιείται είναι πεπερασμένη!\nΚαθαρίστε την προσωρινή μνήμη του browser σας και ανανεώστε αυτή την σελίδα για να χρησιμοποιήσετε την πιο πρόσφατη έκδοση της εφαρμογής.");
            }

            appInitialized = true;
        }

        const onFailure = err => {
        };

        R.handle(R.app.initialize, [], onSuccess, onFailure);
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });


    initializeUser();
    initializeApp();
</script>

{#if appInitialized}
    {#if window.location.pathname === '/reset-password'}
        <ResetPassword/>
    {:else if window.location.pathname === '/sign-up'}
        <SignUp forceSignup/>
    {:else if window.location.pathname === '/confirm-points'}
        <AcceptPoints/>
    {:else}
        <PageLoader/>
        <PopupLoader/>
        <AppHeader/>
        <AppMenu/>
        <main>
            <Route match="/">
                <Route match="/">
                    <Dashboard/>
                </Route>
                <Route match="checkin" let:router>
                    <CheckIn checkinHotel="{ router.id }"/>
                </Route>
                <Route match="hotels">
                    <Hotels/>
                </Route>
                <Route match="confirm-signup">
                    <SignUpConfirm/>
                </Route>
                <Route match="account">
                    <Account/>
                </Route>
                <Route match="reset-password">
                    <ResetPassword/>
                </Route>
                <Route match="transfer-points">
                    <TransferPoints/>
                </Route>
                <Route match="points">
                    <PointsLog/>
                </Route>

                <!--                    <Route match="{APP_PATH}">-->
                <!--                    </Route>-->
            </Route>
        </main>
        {#if $user.showLogin}
            <Login/>
        {/if}
        {#if $user.showSignUp}
            <SignUp/>
        {/if}
        {#if $user.forgotPassword}
            <ForgotPassword/>
        {/if}
    {/if}
{/if}
<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        padding-top: var(--header-height);
    }

    @media (min-width: 1000px) {
        main {
            padding-left: var(--aside-width);
        }
    }
</style>